<template>
  <el-row :gutter="20">
    <el-col :md="12">
    <el-upload
      v-loading="loading"
      class="upload"
      ref="upload"
      drag
      action=""
      :headers="uploadHeader"
      :show-file-list="false"
      :http-request="uploadFiles"
      :auto-upload="true"
      :before-upload="beforeUpload">
      <i class="el-icon-upload"/>
      <div class="el-upload__text">
        Arrastra tu archivo aquí o <em>haz clic para cargarlo</em>
      </div>
      <div slot="tip" class="el-upload__tip">
        Solo se permiten archivos
        <b>.{{fileType.extension}}</b> con un tamaño máximo de <b>{{maxSize}}MB</b>.
      </div>
    </el-upload>
    </el-col>
    <el-col :md="12">
      <el-table
        v-show="FailPoints.length > 0"
        :data="FailPoints"
        style="width: 100%">
        <el-table-column label="Detalle de subordenes inválidas">
          <el-table-column
            prop="row"
            width="70"
            label="Nº"/>
          <el-table-column
            prop="code"
            label="Suborden"/>
          <el-table-column
            prop="errors"
            label="Campos"
            :formatter="formatError"/>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>
</template>

<script>
import axios from 'axios';
import { tenantCode } from '@/mixins/tenants';

export default {
  name: 'upload',
  components: {},
  props: {
    maxSize: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      fileType: {
        extension: 'XLSX',
        format: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      uploadHeader: {
        Authorization: `Bearer ${sessionStorage.token}`,
        'X-Country': tenantCode(),
      },
      FailPoints: [],
      loading: false,
      fileList: [],
      action: '',
      actionValidate: `${process.env.VUE_APP_BASE_API_URL || 'https://txd-geosort-dev-wap.azurewebsites.net/api/'}geocoding-service/v1/import/validate/points`,
      actionQueue: `${process.env.VUE_APP_BASE_API_URL || 'https://txd-geosort-dev-wap.azurewebsites.net/api/'}geocoding-service/v1/import/upload/points`,
    };
  },
  mounted() {
    this.action = this.actionValidate;
  },
  methods: {
    uploadFiles() {
      const fd = new FormData();
      fd.append('file', this.$refs.upload.uploadFiles[0].raw);
      axios.post(this.actionValidate, fd, { headers: this.uploadHeader })
        .then(() => {
          this.$notify.success({
            title: 'Archivo validado',
            message: 'Procesando carga de datos...',
          });
          this.queueData();
        }).catch((e) => {
          this.FailPoints = e.response.data.failPoints;
          this.$notify.error({
            title: 'Error',
            message: e.response.data.message,
          });
          this.$refs.upload.clearFiles();
          this.loading = false;
        });
    },
    queueData() {
      const fd = new FormData();
      fd.append('file', this.$refs.upload.uploadFiles[0].raw);
      axios.post(this.actionQueue, fd, { headers: this.uploadHeader })
        .then(() => {
          this.$notify.success({
            title: 'Archivo cargado',
            message: 'Carga de datos encolados...',
          });
        }).catch((e) => {
          this.FailPoints = e.response.data.failPoints;
          this.$notify.error({
            title: 'Error',
            message: e.response.data.message,
          });
        });
      this.loading = false;
      this.$refs.upload.clearFiles();
    },
    beforeUpload(file) {
      this.FailPoints = [];
      this.action = this.actionValidate;
      this.loading = true;
      return this.validateFile(file.type, file.size);
    },
    validateFile(format, size) {
      const errors = [];
      if (format !== this.fileType.format) errors.push('formato incorrecto');
      if (size / 1024 / 1024 > this.maxSize) errors.push(`tamaño excede los ${this.maxSize}MB`);
      if (errors.length > 0) {
        this.$notify.error({
          title: 'Error',
          message: errors.join(' y '),
        });
        this.loading = false;
      }
      return errors.length === 0;
    },
    formatError(row) {
      return row.errors.join(', ');
    },
  },
};
</script>

<style lang="scss" scoped>
  .el-upload__tip { margin-bottom: 20px; }
</style>
